/* eslint-disable no-prototype-builtins */
import React, { useState, useCallback, useEffect, useRef } from 'react'
import axios from 'axios'
import { useNavigate, useParams } from 'react-router-dom'
import { useDrag, useDrop } from 'react-dnd'

import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent'
import CardActions from '@mui/material/CardActions'
import Collapse from '@mui/material/Collapse'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Link } from '@mui/material'
import StarIcon from '@mui/icons-material/Star'
import SendIcon from '@mui/icons-material/Send'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import DragIndicatorIcon from '@mui/icons-material/DragIndicator'

import { ExpandMore } from '../../../../helpers/cardHelpers'
import { getPayload, getTokenFromLocalStorage, userIsAuthenticated } from '../../../../helpers/storage'
import { selectMediaItemDimension, positionChangeHeightSm, positionChangeWidthSm, swipelyticsPink, swipelyticsTurquoise } from '../../../../helpers/variableDefaults'
import useWindowDimensions from '../../../../helpers/windowDimensions'
import { modifyInDatabase } from '../../../../helpers/modifyInDatabase'
import { dragAndDropIconElement } from '../../../../helpers/buttons'
import { standardErrorContainer } from '../../../../helpers/errors'
import { returnVideoThumbnailFromLiveURL, returnDurationFromLiveURL } from '../../../../helpers/imageHandling'
import { handleSetVideoThumbnailMediaItem } from '../../../../helpers/commonMethods'

const SelectMediaItem = ({ 
  mediaItem, mediaItemIndex,
  selectMediaItem,
  mediaItemURLsInDatingProfileArray,
  datingProfile,
}) => {
  
  // Window Dimensions
  const { height, width } = useWindowDimensions()

  // Payload
  const payload = getPayload()

  // Navigate
  const navigate = useNavigate()

  // Params
  const { estateId, personId } = useParams()

  // URL Path
  const urlPath = window.location.pathname

  // Tracks whether the card is expanded
  const [expanded, setExpanded] = useState(false)

  // Edit Item Error
  const [editItemError, setEditItemError] = useState(false)

  // Video Handling
  const [videoDuration, setVideoDuration] = useState(-1)
  const [videoThumbnail, setVideoThumbnail] = useState('')

  useEffect(() => {
    // console.log('SelectMediaInstanceCard useEffect runs')
    // console.log('mediaItem ->', mediaItem)
    const getData = async () => {
      await handleSetVideoThumbnailMediaItem(mediaItem, setVideoThumbnail, setVideoDuration)
    }

    if (mediaItem.type === 'video') {
      getData()
    }

  }, [])

  // const selectMediaItemDimension = (width) => {
  //   return width < 300 ? '50px' : width < 330 ? '55px' : width < 350 ? '65px' : width < 400 ? '75px' : width < 450 ? '85px' : width < 500 ? '100px' : width < 600 ? '120px' : '135px'
  // }


  useEffect(() => {
    // console.log('useEffect Runs')
    // console.log('videoThumbnail ->', videoThumbnail)

  }, [videoThumbnail])


  return (
    <>
      <Box 
        onClick={(mediaItemURLsInDatingProfileArray().includes(mediaItem.url) || ('portraitURL' in mediaItem && mediaItemURLsInDatingProfileArray().includes(mediaItem.portraitURL))) ? ((e) => e) : (e) => selectMediaItem(e, mediaItemIndex)}
        disabled={(mediaItemURLsInDatingProfileArray().includes(mediaItem.url) || ('portraitURL' in mediaItem && mediaItemURLsInDatingProfileArray().includes(mediaItem.portraitURL)))}
        sx={{ 
          my: 1, 
          // mx: 1,
          width: selectMediaItemDimension(width),
          height: selectMediaItemDimension(width),
          backgroundImage: mediaItem.type === 'image' ? `url(${mediaItem.url})` : `url(${videoThumbnail !== null ? videoThumbnail : ''})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          boxShadow: 3, 
          borderRadius: '5px', 
          cursor: mediaItemURLsInDatingProfileArray().includes(mediaItem.url) ? '' : 'pointer',
          display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end', 
        }}
      >
        {mediaItemURLsInDatingProfileArray().includes(datingProfile.type === 'hinge' ? mediaItem.url : 'portraitURL' in mediaItem ? mediaItem.portraitURL : mediaItem.url) ?
          <Box
            sx={{
              width: selectMediaItemDimension(width),
              height: selectMediaItemDimension(width),
              backgroundColor: 'whitesmoke',
              opacity: '50%',
              display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', alignItems: 'flex-end',
            }}
          />
          :
          videoDuration >= 0 && mediaItem.type === 'video' ?
            <Box
              sx={{
                my: 1, mx: 1,
                backgroundColor: 'white',
                opacity: 0.8,
                fontSize: '14px',
                width: '30px', maxWidth: '30px',
                display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
              }}
            >
              {videoDuration}s
            </Box>
            :
            <></>
        }
      </Box>
    </>

  )
}

export default SelectMediaItem